var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-slider',{attrs:{"tipFormatter":_vm.formatter},on:{"change":_vm.progressChange},model:{value:(_vm.progress),callback:function ($$v) {_vm.progress=$$v},expression:"progress"}})}
var staticRenderFns = []

export { render, staticRenderFns }